/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Crumb_CompareInputs */

const en_vc_crumb_compare = /** @type {(inputs: Vc_Crumb_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Illustrator`)
};

const zh_vc_crumb_compare = /** @type {(inputs: Vc_Crumb_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比 Illustrator`)
};

/**
* | output |
* | --- |
* | "vs Illustrator" |
*
* @param {Vc_Crumb_CompareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_crumb_compare = /** @type {((inputs?: Vc_Crumb_CompareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Crumb_CompareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_crumb_compare(inputs)
	return zh_vc_crumb_compare(inputs)
});
export { vc_crumb_compare as "vc.crumb.compare" }